import { useEffect } from 'react';
import { useAppDispatch } from '../store/store';
import { clearSession, setHydrated, setSession } from '../store/authSlice';
import { TOKEN_KEY, REFRESH_KEY } from '../api/apiClient';
import { getMe } from '../api/services';

/**
 * Al montar la app, intenta restaurar la sesión a partir del JWT en localStorage.
 * Escucha además el evento `csa:logout` que dispara `apiClient` cuando expira el refresh.
 *
 * No hace navegación directa: los `RootGuard` redirigen automáticamente cuando el
 * estado de auth cambia. Por eso este componente puede vivir fuera del RouterProvider.
 */
export default function AuthHydrate() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let cancelled = false;
    async function bootstrap() {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) {
        dispatch(setHydrated(true));
        return;
      }
      try {
        const data = await getMe();
        if (cancelled) return;
        dispatch(setSession({ user: data.user, memberships: data.memberships || [] }));
      } catch (err) {
        if (cancelled) return;
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_KEY);
        dispatch(clearSession());
      }
    }
    bootstrap();
    return () => { cancelled = true; };
  }, [dispatch]);

  useEffect(() => {
    function onLogout() {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(REFRESH_KEY);
      dispatch(clearSession());
    }
    window.addEventListener('csa:logout', onLogout as EventListener);
    return () => window.removeEventListener('csa:logout', onLogout as EventListener);
  }, [dispatch]);

  return null;
}
